import { render, staticRenderFns } from "./PlacementMultiplierEx.vue?vue&type=template&id=7365bb14&scoped=true&shadow"
import script from "./PlacementMultiplierEx.vue?vue&type=script&lang=js&shadow"
export * from "./PlacementMultiplierEx.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7365bb14",
  null
  ,true
)

export default component.exports